/*
 * Catalog tools above the grid: size chips and the density switch.
 *
 * Size chips filter the cards already on the page by the in-stock sizes each
 * card carries in data-cp-sizes ("|S|M|"), and keep filtering what the
 * infinite scroll appends. No request, no reload, and the count in the
 * header follows. The chip is also written to the URL (?size=M) so the back
 * button and a shared link keep it.
 *
 * Density: one big card per row on a phone (.is-one-col on the grid), kept
 * in localStorage because it is a way of looking, not a one-off.
 */
(function () {
  var tools = document.querySelector('[data-cp-tools]');
  var grid = document.getElementById('product-grid');
  if (!tools || !grid) return;

  var active = null;
  var countEl = document.querySelector('[data-cp-count]');
  var baseCount = countEl ? countEl.textContent : '';

  function cards() { return grid.querySelectorAll('li.product-grid__item'); }

  function apply() {
    var shown = 0;
    cards().forEach(function (li) {
      var card = li.querySelector('.minimal-card');
      var ok = !active || (card && (card.dataset.cpSizes || '').indexOf('|' + active + '|') !== -1);
      li.hidden = !ok;
      if (ok) shown += 1;
    });
    tools.querySelectorAll('[data-cp-size]').forEach(function (b) {
      var on = b.dataset.cpSize === active;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', String(on));
    });
    if (countEl) {
      var total = (baseCount.match(/\d+/) || [''])[0];
      countEl.textContent = active ? shown + ' із ' + total + ' · розмір ' + active : baseCount;
    }
    if (window.cpTrack && active) window.cpTrack('cp_size_chip', { size: active, shown: shown });
  }

  tools.addEventListener('click', function (event) {
    var chip = event.target.closest('[data-cp-size]');
    if (chip) {
      active = active === chip.dataset.cpSize ? null : chip.dataset.cpSize;
      var url = new URL(location.href);
      if (active) url.searchParams.set('size', active); else url.searchParams.delete('size');
      history.replaceState(null, '', url);
      apply();
      return;
    }
    var dens = event.target.closest('[data-cp-density]');
    if (dens) setDensity(dens.dataset.cpDensity);
  });

  function setDensity(n) {
    grid.classList.toggle('is-one-col', n === '1');
    tools.querySelectorAll('[data-cp-density]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.cpDensity === n));
    });
    try { localStorage.setItem('cp:density', n); } catch (e) {}
    if (window.cpTrack) window.cpTrack('cp_density', { columns: n });
  }

  var saved = null;
  try { saved = localStorage.getItem('cp:density'); } catch (e) {}
  if (saved === '1') setDensity('1');

  var fromUrl = new URLSearchParams(location.search).get('size');
  if (fromUrl) { active = fromUrl.toUpperCase(); apply(); }

  // Cards the infinite scroll appends later get the same filter.
  new MutationObserver(function () { if (active) apply(); }).observe(grid, { childList: true });
})();
